import React, { Component } from "react";
import openSocket from "socket.io-client";
import CryptoJS from "react-native-crypto-js";
import crypto, { createHmac } from "crypto";
import data from "./api";
import { store } from "react-notifications-component";
import "./App.css";
import Swal from "sweetalert2";
import { SHA256 } from "crypto-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faCaretDown, faClose } from "@fortawesome/free-solid-svg-icons";
import logo from "./Logo-EarthID-white.png"
import withReactContent from 'sweetalert2-react-content';
import axios from "axios";

const QR_TYPE_MAP = {
  register: "Connect Wallet",
  document: "Identity Verification",
  selectiveData: "Verify Credentials",
  idvProof: "Prove Identity",
  minAge: "Age Verification",
  ageRange: "Age Range Verification",
  balance: "Eligibility Check",
  default: "Verify Identity"
};

// export const isTestnet = true;
// const socketURL =
//   isTestnet === true
//     ? "https://socket-stagev2.myearth.id"
//     : "https://socketv2.myearth.id";
// const socket = openSocket(socketURL, {
//   transports: ["websocket", "polling", "flashsocket"],
// });
// let socketId;
// socket.on("connect", () => {
//   socketId = socket.id;
//   //console.log(`I'm connected with the back-end`);
// });

const {
  listenForUserData,
  listenForServiceProviderResponse,
  getApiKey,
  generateQrCodeNest,
  getUserCreditnals,
  generateqr,
  registerVendor,
  getVendor
} = data;

let showNotification = true;


class KycFlow extends Component {
  
  state = {
    showSpinner: false,
    showBtn: true,
    requestNo: "",
    qrcode: false,
    response: false,
    email: "",
    mno: "",
    profileDrop: false,
    btnText: "Login with Earth Id",
    showText: true,
    showModal: true,
    modalHeading: false,
    createDid: "",
    creditnals: "",
    isSubmitDisabled: true,
    qrType: "default",
  };



  loader = () => {
    this.setState({ showBtn: false, modalHeading: true });
    this.setState({ qrcode: true, showSpinner: false });
    if (!this.state.showModal) {
      this.setState({
        showModal: true,
      });
    }
    if (this.state.loggedIn) {
      localStorage.removeItem("email");
      localStorage.removeItem("mobile_no");
      localStorage.removeItem("user_name");
      localStorage.removeItem("dob");
      localStorage.removeItem("e_verified");
      localStorage.removeItem("trust_score");
      localStorage.removeItem("earth_id");
      localStorage.removeItem("m_verified");
      this.setState({
        loggedIn: false,
        btnText: "Login with Earth Id",
        qrcode: true,
        response: false,
        showModal: false,
      });
      setTimeout(() => {
        document.getElementById("exampleModal").click();
      }, 0);
      this.redirectToHome();
    }
  };

  componentDidMount = async () => {
    if (localStorage.email != null) {
        this.setState({
            loggedIn: true,
            btnText: "LogOut",
        });
    }
    if (!this.state.apiKey) {
        this.state.apiKey = getApiKey();
    }
};

updateNotificationState = () => {
    setTimeout(() => {
        showNotification = true;
    }, 100);
};

verifyNotificationState = () => {
    setTimeout(() => {
        showNotification = true;
    }, 100);
};

userDenied = () => {
    this.setState({
        response: false,
        showModal: false,
    });
    setTimeout(() => {
        document.getElementById("exampleModal").click();
        if (showNotification === true) {
            showNotification = false;
            store.addNotification({
                title: "Error!",
                message: `User Didn't Authorize!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 3000,
                    onScreen: true,
                },
            });
        }
    }, 0);
};

// Register functions

listenForSocketRegister = () => {
  listenForServiceProviderResponse((err, res) => {
    this.setState({
      qrcode: false,
      response: false,
      showSpinner: true,
      showText: false,
    });
  });

  listenForUserData(async (err, res) => {
    let bytes = res.userDetails || res.newreq;
    
    this.setState({
      showQr: false,
      showSpinner: false,
    });

    if (bytes === "denied" || bytes.permission === "denied") {
      this.userDenied();
    } else if (bytes.permission === "granted" || bytes.success || bytes.userDid) {
      console.log('this is user register data:', bytes)
      // --- START OF BACKEND INTEGRATION ---
      
      // 1. Prepare the payload from EarthID response

      const signupData = {
        name: bytes.userName || "EarthID User",
        phone: bytes.userMobileNo || "Not Provided",
        email: bytes.userEmail || "",
        userDid: bytes.userDid,
        earthId: bytes.earthId, 
        mediatorUrl: bytes.mediatorUrl || "https://default.mediator.com",
        fcmToken: bytes.fcmToken || "",
      };
      console.log('this is user register data2:', signupData)
      try {
        const response = await fetch("https://sangrahapi.myearth.id/api/v1/users/link-did", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(signupData),
        });

        const apiResult = await response.json();
console.log('this is user register api response:', apiResult)
        if (apiResult.success) {
          // Success Alert
          Swal.fire({
            icon: 'success',
            title: 'Registration Successful',
            text: 'Your Sangrah wallet has been linked successfully.',
            timer: 3000,
            showConfirmButton: false
          });

          // Standard App Logic
          this.setState({
            response: true,
            loggedIn: true,
            showModal: false,
            btnText: "LogOut",
          });
          
          // Close the QR Modal programmatically
          document.getElementById("exampleModal").click();

        } else {
          throw new Error(apiResult.message || "Backend registration failed");
        }

      } catch (error) {
        console.error("Registration Error:", error);
        
        // Failure Alert
        Swal.fire({
          icon: 'error',
          title: 'Registration Failed',
          text: error.message || 'Could not connect to the Bank Server.',
        });
      }
      
      // --- END OF BACKEND INTEGRATION ---

    } else {
      this.userDenied();
    }
  });
};

generateQrCodeDataRegister = async () => {

  registerVendor()
      .then((d) => {
          const timestamp = Date.now();
          const hash = crypto
              .createHmac("sha256", d.secretKey)
              .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
              .digest("hex");
          generateQrCodeNest(hash, d.apiKey, "Rejolut@1008", timestamp, "register")
              .then((data) => {
                  this.listenForSocketRegister();
                  this.setState({
                      showQr: true,
                      qrCodeData: data,
                      apiKey: this.state.apikey,
                      qrcode: false,
                      qrType: "register",
                  });
              })
              .catch((err) => {
                  alert(err);
              });
      })
      .catch((err) => {
          alert(err);
      });
};

listenForSocket = () => {
    listenForServiceProviderResponse((err, res) => {
        this.setState({
            qrcode: false,
            response: false,
            showSpinner: true,
            showText: false,
        });
    });

  listenForUserData(async (err, res) => {
        let bytes = res.userDetails || res.newreq;
        //sessionStorage.setItem('profileData', JSON.stringify(bytes));
console.log('Got zkp data', bytes)
        console.log()
        console.log("bytes", bytes);
        console.log("Response", res);
        this.setState({
            showQr: false,
            showSpinner: false,
        });
        let creditnals;
        let sessionKey;
        if (bytes === "denied" || bytes.permission === "denied") {
            this.userDenied();
        } else if (
            bytes.permission === "granted" ||
            bytes === "issuerLogin" ||
            bytes === "credentialsgenerated" ||
            bytes === "verifylogin" ||
            bytes === "success"
        ) {
            this.setState({
                response: true,
                showSpinner: false,
                loggedIn: true,
                showModal: false,
                btnText: "LogOut",
                bytes: "credentialsgenerated",
            });
            setTimeout(() => {
                document.getElementById("exampleModal").click();
                let popMessage;
                // if (showNotification === true) {
                //     if (this.state.bytes === "credentialsgenerated") {
                //         popMessage = "Credentials Generated";
                //     } else {
                //         popMessage = `Login Successful`;
                //     }
                //     showNotification = false;
                //     store.addNotification({
                //         title: "Success!",
                //         message: popMessage,
                //         type: "success",
                //         insert: "top",
                //         container: "top-right",
                //         animationIn: ["animated", "fadeIn"],
                //         animationOut: ["animated", "fadeOut"],
                //         dismiss: {
                //             duration: 3000,
                //             onScreen: true,
                //         },
                //     });
                //     if (bytes.permission === "granted") {
                //         this.updateNotificationState();
                //     } else if (bytes === "verifylogin") {
                //         this.verifyNotificationState();
                //     }
                // }
            }, 0);
        } else if (bytes.userDetails.credentialType != null) {
            console.log("bytes", bytes);
            sessionKey = bytes.sessionKey;
            await getUserCreditnals(bytes.userDetails)
                .then((data) => {
                    this.userCreditnalsSuccess(bytes);

                    creditnals = data;
                })
                .catch((err) => {
                    alert(err);
                });
        } else {
            this.setState({
                response: false,
                showModal: false,
            });
            setTimeout(() => {
                document.getElementById("exampleModal").click();
                if (showNotification === true) {
                    showNotification = false;
                    store.addNotification({
                        title: "Error!",
                        message: `User Didn't Authorize!`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 3000,
                            onScreen: true,
                        },
                    });
                }
            }, 0);
        }
    });
};

userCreditnalsSuccess = (data) => {
    if (data.userDetails.credentialType != null) {
        this.setState({
            response: true,
            showSpinner: false,
            loggedIn: true,
            showModal: false,
            btnText: "LogOut",
        });
        setTimeout(() => {
            document.getElementById("exampleModal").click();
            let popMessage;
            if (showNotification === true) {
                popMessage = "Credentials Generated";
                showNotification = false;
                store.addNotification({
                    title: "Success!",
                    message: popMessage,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        onScreen: true,
                    },
                });
            } else {
                this.setState({
                    response: false,
                    showModal: false,
                });
                setTimeout(() => {
                    document.getElementById("exampleModal").click();
                    if (showNotification === true) {
                        showNotification = false;
                        store.addNotification({
                            title: "Error!",
                            message: `User Didn't Authorize!`,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 3000,
                                onScreen: true,
                            },
                        });
                    }
                }, 0);
            }
        }, 0);
    }
};


/********* KYC function ************/  
QrCodeDataKYC = () => {
  //registerVendor()
  getVendor()
      .then((d) => {
          const timestamp = Date.now();
          const hash = crypto
              .createHmac("sha256", d.secretKey)
              .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
              .digest("hex");
        console.log('apikey', d.secretKey)
          generateQrCodeNest(
              hash,
              d.apiKey,
              "Rejolut@1008",
              timestamp,
              "document"
          )
              .then((data) => {
                console.log('data', data)
                  this.listenForSocket();
                  this.setState({
                      showQr: true,
                      qrCodeData: data,
                      apiKey: this.state.apikey,
                      qrcode: false,
                      qrType: "document",
                  });
                  this.props.onComplete();
                  console.log("test");
              })
              .catch((err) => {
                  alert(err);
              });
      })
      .catch((err) => {
          alert(err);
      });
};




qrcode = () => {
    let { qrCodeData } = this.state;
    return (
        <div className="qr-container">
            <img src={qrCodeData} alt="new" />
        </div>
    );
};

redirectToHome() {
    window.location.href = "/";
}
redirectToGenerateCred() {
    window.location.href = "/generateCred";
}

redirectToVerifyCreditnals() {
    window.location.href = "/verifyCredentials";
}


/********* SDD function ************/  
QrCodeDataSDD = () => {
  //registerVendor()
  getVendor()
      .then((d) => {
          const timestamp = Date.now();
          const hash = crypto
              .createHmac("sha256", d.secretKey)
              .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
              .digest("hex");
        console.log('apikey', d.secretKey)
          generateQrCodeNest(
              hash,
              d.apiKey,
              "Rejolut@1008",
              timestamp,
              "selectiveData"
          )
              .then((data) => {
                console.log('data', data)
                  this.listenForSocket();
                  this.setState({
                      showQr: true,
                      qrCodeData: data,
                      apiKey: this.state.apikey,
                      qrcode: false,
                      qrType: "selectiveData",
                  });
                  this.props.onComplete();
                  console.log("test");
              })
              .catch((err) => {
                  alert(err);
              });
      })
      .catch((err) => {
          alert(err);
      });
};


/********* IDV function ************/  
QrCodeDataIDV = () => {
  //registerVendor()
  const idvData = {
    "request": "idvProof",
    "company": "EarthID"
  }
  const idvDataString = JSON.stringify(idvData);
  const jsonStringWithSingleQuotes = idvDataString.replace(/"/g, "'");

  console.log(jsonStringWithSingleQuotes);

  getVendor()
      .then((d) => {
          const timestamp = Date.now();
          const hash = crypto
              .createHmac("sha256", d.secretKey)
              .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
              .digest("hex");
        console.log('apikey', d.secretKey)
          generateQrCodeNest(
              hash,
              d.apiKey,
              "Rejolut@1008",
              timestamp,
              jsonStringWithSingleQuotes
          )
              .then((data) => {
                console.log('data', data)
                  this.listenForSocket();
                  this.setState({
                      showQr: true,
                      qrCodeData: data,
                      apiKey: this.state.apikey,
                      qrcode: false,
                      qrType: "idvProof",
                  });
                  this.props.onComplete();
                  console.log("test");
              })
              .catch((err) => {
                  alert(err);
              });
      })
      .catch((err) => {
          alert(err);
      });
};


/********* ZKP function ************/  

listenForZKPSocket = (zkpData) => {
  listenForServiceProviderResponse((err, res) => {
      this.setState({
          qrcode: false,
          response: false,
          showSpinner: true,
          showText: false,
      });
  });

listenForUserData(async (err, res) => {
      let bytes = res.userDetails || res.newreq;
      //sessionStorage.setItem('profileData', JSON.stringify(bytes));
console.log('Got zkp data', bytes)
      console.log()
      console.log("bytes", bytes);
      console.log("Response", zkpData);
      this.setState({
          showQr: false,
          showSpinner: false,
      });
      let creditnals;
      let sessionKey;

      const MySwal = withReactContent(Swal);

    // Check if certificate object exists and has properties
if (bytes.certificate && typeof bytes.certificate === 'object' && Object.keys(bytes.certificate).length > 0) {
  console.log('Certificate object exists with properties:');

  // Loop through each property in the certificate object
  for (const property in bytes.certificate) {
    if (Object.hasOwnProperty.call(bytes.certificate, property)) {
      const value = bytes.certificate[property];
console.log('zkpcert', zkpData)
      // Perform actions based on the property and its value
      console.log(`Property: ${property}, Value: ${value}`);
//const zkpStringData = JSON.stringify(zkpData)
      // Example: Check if the value is true

if(property == "dateOfBirth" && value === true && zkpData.request=="minAge"){
  MySwal.fire({
    icon: 'success',
    title: `Successfully verified that the user's age is above ${zkpData.value}`,
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: 'Close',
    onClose: () => {
      // Add your onClick logic here
      this.refreshPage()
      // You can perform additional actions when the close button is clicked
    },
  });
}else if(property == "balance" && value === true && property == zkpData.request){
  MySwal.fire({
    icon: 'success',
    title: `Successfully verified that the user has a minimum balance of ${zkpData.minimum}`,
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: 'Close',
    onClose: () => {
      // Add your onClick logic here
      this.refreshPage()
      // You can perform additional actions when the close button is clicked
    },
  });
}else {
  console.log(`Value of ${property} is false. Do something for false.`);
  MySwal.fire({
    icon: 'error',
    title: `Verification Failed. The user doesn't have a minimum balance of ${zkpData.minimum}`,
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: 'Close',
    onClose: () => {
      // Add your onClick logic here
      this.refreshPage()
      // You can perform additional actions when the close button is clicked
    },
  });
}


      // if (value === true) {
      //   console.log(`Value of ${property} is true. Do something for true.`);
      //   if(zkpData.value){
      //     MySwal.fire({
      //       icon: 'success',
      //       title: `Successfully verified that the user's age is above ${zkpData.value}`,
      //       showCloseButton: true,
      //       showCancelButton: false,
      //       focusConfirm: false,
      //       confirmButtonText: 'Close',
      //       onClose: () => {
      //         // Add your onClick logic here
      //         this.refreshPage()
      //         // You can perform additional actions when the close button is clicked
      //       },
      //     });
      //   }else if(zkpData.minimum){
      //     MySwal.fire({
      //       icon: 'success',
      //       title: `Successfully verified that the user has a minimum balance of ${zkpData.minimum}`,
      //       showCloseButton: true,
      //       showCancelButton: false,
      //       focusConfirm: false,
      //       confirmButtonText: 'Close',
      //       onClose: () => {
      //         // Add your onClick logic here
      //         this.refreshPage()
      //         // You can perform additional actions when the close button is clicked
      //       },
      //     });
      //   }
        
      // } else {
      //   console.log(`Value of ${property} is false. Do something for false.`);
      //   MySwal.fire({
      //     icon: 'error',
      //     title: `Verification Failed`,
      //     showCloseButton: true,
      //     showCancelButton: false,
      //     focusConfirm: false,
      //     confirmButtonText: 'Close',
      //     onClose: () => {
      //       // Add your onClick logic here
      //       this.refreshPage()
      //       // You can perform additional actions when the close button is clicked
      //     },
      //   });
      // }
    }
  }
} else {
  console.log('Certificate object does not exist or is empty.');
  MySwal.fire({
    icon: 'error',
    title: 'Verification Failed. Please retry.',
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: 'Close',
    onClose: () => {
      // Add your onClick logic here
      this.refreshPage()
      // You can perform additional actions when the close button is clicked
    },
  });
}




      if (bytes === "denied" || bytes.permission === "denied") {
          this.userDenied();
      } else if (
          bytes.permission === "granted" ||
          bytes === "issuerLogin" ||
          bytes === "credentialsgenerated" ||
          bytes === "verifylogin" ||
          bytes === "success"
      ) {
          this.setState({
              response: true,
              showSpinner: false,
              loggedIn: true,
              showModal: false,
              btnText: "LogOut",
              bytes: "credentialsgenerated",
          });
          setTimeout(() => {
              document.getElementById("exampleModal").click();
              let popMessage;
              // if (showNotification === true) {
              //     if (this.state.bytes === "credentialsgenerated") {
              //         popMessage = "Credentials Generated";
              //     } else {
              //         popMessage = `Login Successful`;
              //     }
              //     showNotification = false;
              //     store.addNotification({
              //         title: "Success!",
              //         message: popMessage,
              //         type: "success",
              //         insert: "top",
              //         container: "top-right",
              //         animationIn: ["animated", "fadeIn"],
              //         animationOut: ["animated", "fadeOut"],
              //         dismiss: {
              //             duration: 3000,
              //             onScreen: true,
              //         },
              //     });
              //     if (bytes.permission === "granted") {
              //         this.updateNotificationState();
              //     } else if (bytes === "verifylogin") {
              //         this.verifyNotificationState();
              //     }
              // }
          }, 0);
      } else if (bytes.userDetails.credentialType != null) {
          console.log("bytes", bytes);
          sessionKey = bytes.sessionKey;
          await getUserCreditnals(bytes.userDetails)
              .then((data) => {
                  this.userCreditnalsSuccess(bytes);

                  creditnals = data;
              })
              .catch((err) => {
                  alert(err);
              });
      } else {
          this.setState({
              response: false,
              showModal: false,
          });
          setTimeout(() => {
              document.getElementById("exampleModal").click();
              if (showNotification === true) {
                  showNotification = false;
                  store.addNotification({
                      title: "Error!",
                      message: `User Didn't Authorize!`,
                      type: "danger",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                          duration: 3000,
                          onScreen: true,
                      },
                  });
              }
          }, 0);
      }
  });
};

QrCodeDataZKP = (zkpData) => {

  console.log('QrZKPData', zkpData)
  const zkpDataString = JSON.stringify(zkpData);
  const jsonStringWithSingleQuotes = zkpDataString.replace(/"/g, "'");

  console.log(jsonStringWithSingleQuotes);
  //registerVendor()
  getVendor()
      .then((d) => {
          const timestamp = Date.now();
          const hash = crypto
              .createHmac("sha256", d.secretKey)
              .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
              .digest("hex");
        console.log('apikey', d.secretKey)
          generateQrCodeNest(
              hash,
              d.apiKey,
              "Rejolut@1008",
              timestamp,
              jsonStringWithSingleQuotes
          )
              .then((data) => {
                console.log('data', data)
                  this.listenForZKPSocket(zkpData);
                  this.setState({
                      showQr: true,
                      qrCodeData: data,
                      apiKey: this.state.apikey,
                      qrcode: false,
                      qrType: zkpData.request,
                  });
                  this.props.onComplete();

                  console.log("test");
              })
              .catch((err) => {
                  alert(err);
              });
      })
      .catch((err) => {
          alert(err);
      });
};

// ZKP flow
openPopupBox = () => {
  const MySwal = withReactContent(Swal);

  MySwal.fire({
    title: 'Add ZKP Condition',
    html: (
      <div>

{/* <form class="was-validated">
  <div class="mb-3">
    <label for="validationTextarea">Textarea</label>
    <textarea class="form-control is-invalid" id="validationTextarea" placeholder="Required example textarea" required></textarea>
    <div class="invalid-feedback">
      Please enter a message in the textarea.
    </div>
  </div>
  </form> */}

        {/* Dropdown */}
        <label className="custom-title" htmlFor="dropdown">Select the condition for ZKP:</label>
        <br />
        <select id="dropdown" className="custom-dropdown">
        <option value="">Select...</option>
         {/* <option value="value">Age</option>*/}
          <option value="minimum">Balance</option>
          {/* Add more options as needed */}
        </select>
        <br />
        {/* Input text box */}
        <label htmlFor="inputText">Enter minimum value for the condition:</label>
        <br />
        <input type="text" id="inputText" className="custom-input"/>
        <br />
        {/* Buttons */}
        
        <button
          className="custom-button"
          data-toggle="modal"
  data-target="#exampleModal"
          onClick={this.submitForm}
        >
          Submit
        </button>

        <button className="custom-button" onClick={this.refreshPage}>
          Close
        </button>
      </div>
    ),
    showCancelButton: false,
    showConfirmButton: false,
    focusConfirm: false,
    preConfirm: () => { 
    },
  })
};

// Function to close the SweetAlert modal
closePopupBox = () => {
  Swal.close();
};



// Function to handle form submission
submitForm = () => {
  // Collect the entire form data into a JSON object
  const formDataJson = {
    dropdownValue: document.getElementById('dropdown').value,
    inputValue: document.getElementById('inputText').value,
  };

  // Log the form data to the console
  console.log('Form Data:', formDataJson);
let zkpData
  if(formDataJson.dropdownValue == "value"){
    zkpData = {
      "request": "minAge",
      "type": "date",
    "value": formDataJson.inputValue,
    "unit": "years"
    }
  }else if(formDataJson.dropdownValue == "minimum"){
    zkpData = {
      "request": "balance",
      "type": "number",
    "minimum": formDataJson.inputValue
    }
  }else{
    console.log("No value selected!")
  }
console.log("ZkpData", zkpData)
// const jsonString = "{\"apikey\":\"EGZEUSHEUHF\",\"reqNo\":\"3336dc18-5c72-430b-b6f8-0e3c6a6a4df7\",\"sessionKey\":\"3336dc18-5c72-430b-b6f8-0e3c6a6a4df7\",\"requestType\":\"{\'request\':\'minAge\',\'type\':\'date\',\'value\':\'18\',\'unit\':\'years\'}\" }"
// const stringWithDoubleBackslashes = jsonString.replace(/'/g, '\\"');

// try {

//   const jsonObject = JSON.parse(stringWithDoubleBackslashes);

//   jsonObject.requestType = JSON.parse(jsonObject.requestType);

//   console.log('Parsed Object:', jsonObject);
// } catch (error) {
//   console.error('Error parsing JSON:', error);
// }
if(formDataJson.dropdownValue==''){
  Swal.showValidationMessage('Please select a condition for ZKP');
}else if(formDataJson.inputValue==''){
  Swal.showValidationMessage('Please enter a minimum value for the condition');
}
else{
  this.QrCodeDataZKP(zkpData)
  // Close the SweetAlert modal
  this.closePopupBox();

  
  // Trigger Bootstrap modal using JavaS
  // this.setState({ showModal: true }, () => {
  //   console.log('showModal state:', this.state.showModal);
  // });
  }
};



verifyZKP = async (zkpResult, credential, verifierPublicKey) => {
  try {
    const zkpCertificate = {
      certificate: zkpResult.certificate,
      publicKey: zkpResult.publicKey,
      zkpSignature: zkpResult.zkpSignature,
      userSignature: credential.userSignature
    }
    // Prepare the request payload
    const payload = {
      credentials: credential.verifiableCredential,
      zkpCertificate: zkpCertificate
    };

    console.log("🔵 Payload for Verification API:", JSON.stringify(payload, null, 2));

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://ssi-test.myearth.id/api/verifier/verify?zpkValidation=true',
      headers: {
        'X-API-KEY': '01a41742-aa8e-4dd6-8c71-d577ac7d463c', // Your API Key
        'publicKey': verifierPublicKey, // Dynamic publicKey
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload)
    };

    const response = await axios.request(config);
    console.log('✅ Verification Success:', response.data);

    return response.data.data; // return result to caller
  } catch (error) {
    console.error('❌ Verification Failed:', error.response.data || error.message);
    throw error;
  }
};



listenForAgeSocket = (ageData) => {
  listenForServiceProviderResponse((err, res) => {
    this.setState({
      qrcode: false,
      response: false,
      showSpinner: true,
      showText: false,
    });
  });

  listenForUserData(async (err, res) => {
    const bytes = res.userDetails || res.newreq;
    this.setState({
      showQr: false,
      showSpinner: false,
    });
    document.getElementById("exampleModal").click(); 

const zkpResult = bytes.zkpResult
console.log('this is zkpResult:', zkpResult)
const zkpVC = bytes.zkpVc
console.log('this is zkpResult:', zkpVC)

const MySwal = withReactContent(Swal);

MySwal.fire({
  title: 'Verifying Proof',
  html: 'Please wait while we validate the Proof...',
  allowOutsideClick: false,
  didOpen: () => {
    MySwal.showLoading();
  }
});

const zkpVerifyResult = await this.verifyZKP(zkpResult, zkpVC, bytes.publicKey)
console.log('this is verify zkp result:-------', zkpVerifyResult)

 // Close loading Swal
 MySwal.close();

    if (zkpVerifyResult.zkpMessage && typeof zkpVerifyResult.zkpMessage === 'object' && Object.keys(zkpVerifyResult.zkpMessage).length > 0) {
      document.getElementById("exampleModal").click(); // <-- closes the modal

      for (const property in zkpVerifyResult.zkpMessage) {
        const value = zkpVerifyResult.zkpMessage[property];

        if (property === "dateOfBirth" && value === true) {
          if (ageData.request === "minAge") {
            MySwal.fire({
              icon: 'success',
              title: `Successfully verified that the user's age is above ${ageData.value}`,
              confirmButtonText: 'Close',
              onClose: () => this.refreshPage(),
            });
          } else if (ageData.request === "ageRange") {
            MySwal.fire({
              icon: 'success',
              title: `Successfully verified that user's age is between ${ageData.minValue} and ${ageData.maxValue}`,
              confirmButtonText: 'Close',
              onClose: () => this.refreshPage(),
            });
          }
        } else {
          MySwal.fire({
            icon: 'error',
            title: `Verification Failed. The user's age does not satisfy the provided condition.`,
            confirmButtonText: 'Close',
            onClose: () => this.refreshPage(),
          });
        }
      }
    } else {
      MySwal.fire({
        icon: 'error',
        title: 'Verification Failed. Please retry.',
        confirmButtonText: 'Close',
        onClose: () => this.refreshPage(),
      });
    }
  });
};


QrCodeDataAge = (ageData) => {
  console.log('QrCodeDataAge:', ageData);
  const ageDataString = JSON.stringify(ageData);
  const jsonStringWithSingleQuotes = ageDataString.replace(/"/g, "'");

  getVendor()
    .then((d) => {
      const timestamp = Date.now();
      const hash = crypto
        .createHmac("sha256", d.secretKey)
        .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
        .digest("hex");

      generateQrCodeNest(
        hash,
        d.apiKey,
        "Rejolut@1008",
        timestamp,
        jsonStringWithSingleQuotes
      )
        .then((data) => {
          this.listenForAgeSocket(ageData); // 🔄 Update: call correct socket listener
          this.setState({
            showQr: true,
            qrCodeData: data,
            apiKey: this.state.apikey,
            qrcode: false,
            qrType: ageData.request,
          });
          this.props.onComplete();
        })
        .catch((err) => {
          alert(err);
        });
    })
    .catch((err) => {
      alert(err);
    });
};


// Age Verification flow
openPopupBoxAge = () => {
  const MySwal = withReactContent(Swal);

  MySwal.fire({
    title: 'Age Verification',
    html: (
      <div>
        <label className="custom-title" htmlFor="ageDropdown">Select the condition for age verification:</label>
        <br />
        <select id="ageDropdown" className="custom-dropdown">
          <option value="">Select...</option>
          <option value="13-16">13-16 years</option>
          <option value="18">18+ years</option>
          <option value="21">21+ years</option>
        </select>
        <br />
        
        <button
          className="custom-button"
          data-toggle="modal"
          data-target="#exampleModal"
          onClick={this.submitFormAge}
        >
          Submit
        </button>

        <button className="custom-button" onClick={this.refreshPage}>
          Close
        </button>
      </div>
    ),
    showCancelButton: false,
    showConfirmButton: false,
    focusConfirm: false,
  });
};


// Function to close the SweetAlert modal
closePopupBoxAge = () => {
  Swal.close();
};



// Function to handle form submission
submitFormAge = () => {
  const dropdown = document.getElementById('ageDropdown');
  const selectedValue = dropdown.value;

  if (!selectedValue) {
    Swal.showValidationMessage('Please select a condition for age verification');
    return;
  }

  let ageData;

  if (selectedValue === "13-16") {
    ageData = {
      request: "ageRange",
      type: "date",
      minValue: "13",
      maxValue: "16",
      unit: "years"
    };
  } else {
    ageData = {
      request: "minAge",
      type: "date",
      value: selectedValue,
      unit: "years"
    };
  }

  console.log("Age Verification Data:", ageData);
  this.QrCodeDataAge(ageData);
  this.closePopupBoxAge();
};



refreshPage = () => {
  window.location.reload();
};

  render() {
    let showButton = this.state.showSpinner ? (
      <div className="spinner-div">
        <img className="spinner" src={require("./spinner.gif")} />
      </div>
    ) : null;
    return (
      <>
<div className="App">
<nav className="navbar navbar-expand-lg navbar-light">
          <div
            className=" collapse navbar-collapse pull-right "
            id="navbarTogglerDemo01"
          >
            <div className="clickable" onClick={() => window.open("https://www.myearth.id/")}> 
              <img src={logo} alt="logo" className="logo"  />{" "}
            </div>
            <ul className=" navbar-nav mr-auto mt-2 mt-lg-0" style={{marginLeft:"1.5rem", textTransform:"uppercase"
            , color:"White"}}>
                    <li className="nav-item">
                        <a className="nav-link active" aria-current="page" href="#">Plans</a>
                    </li>
                    {/* <li className="nav-item">
                        <a className="nav-link" href="#">Services</a>
                    </li> */}
                    <li className="nav-item">
                        <a className="nav-link" href="#">Business</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#">Investment</a>
                    </li>
            </ul>

            {localStorage.user_name ? (
              <div>
                <label className="welcomeLabel">{`Welcome, ${localStorage.getItem(
                  "user_name"
                )}`}</label>
              </div>
            ) : null}
            <button
                  type="button"
                  className="nav-buttons"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  onClick={this.state.btnText=="LogOut"?this.redirectToHome:this.generateQrCodeDataRegister}
                  style={{  }}
                >
                  Connect Wallet
                </button>
        <div className="dropdown">
        <button
          className='nav-buttons dropdown-toggle'
          type='button'
          id='certificateDropdown'
          data-toggle='dropdown'
          aria-haspopup='true'
          aria-expanded='false'
          style={{ marginRight: "0.5rem", }}
        >
          Identity Verification <FontAwesomeIcon className='dropdownfont' icon={faCaretDown} />
        </button> 
        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <button
            type="button"
            className="dropdown-item"
            data-toggle="modal"
            data-target="#exampleModal"
            onClick={this.QrCodeDataKYC}
          >
            Identity Verification
          </button>
          <button
            type="button"
            className="dropdown-item"
            data-toggle="modal"
            data-target="#exampleModal"
            onClick={this.QrCodeDataSDD}
          >
            Verify Credentials
          </button>
          <button
            type="button"
            className="dropdown-item"
            onClick={this.openPopupBox}
          >
            Confirm Eligibility
          </button>
          <button
            type="button"
            className="dropdown-item"
            data-toggle="modal"
            data-target="#exampleModal"
            onClick={this.QrCodeDataIDV}
          >
            Prove IDV
          </button>
          <button
            type="button"
            className="dropdown-item"
            onClick={this.openPopupBoxAge}
          >
            Verify Age
          </button>
        </div>
      </div>
                    
                   
                  <button
                    type="button"
                    className="nav-buttons"
                    onClick={this.redirectToHome}
                  >
                    Logout
                  </button>

          <div className="modal_container" id="modal-container">
            <div className="modal">
              <div className="qr-code">
                <img
                  src='https://api.qrserver.com/v1/create-qr-code/?data={"apikey":"UKURGTREFATPSYJ","reqNo":"BAZQUVRDTLF","sessionKey":"BAZQUVRDTLF","requestType":"login","encryptionkey":"loginDetailsEncryption" }'
                  alt="QR-Code"
                />
              </div>

              <button id="btn-close">Close me</button>
            </div>
          </div>

          </div>
          </nav>
          </div>
     
       <div className="hero-section">
  <div className="shoppingCart"></div>
  <div
    className="modal fade"
    id="exampleModal"
    role="dialog"
    aria-labelledby="exampleModalLabel"
  >
    <div className="modal-dialog" role="document">
      {this.state.showModal && (
        <div className="modal-content" style={{ borderRadius: '15px', overflow: 'hidden' }}>
          {/* Modal Header */}
          <div className="close-button-containerr" style={{ borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <h4 style={{ color: "black", margin: 0, fontWeight: '600' }}>
    {QR_TYPE_MAP[this.state.qrType] || QR_TYPE_MAP.default}
  </h4>
  <FontAwesomeIcon 
    className="close-buttonn" 
    data-dismiss="modal" 
    icon={faClose} 
    style={{ cursor: 'pointer', fontSize: '20px' }}
  />
</div>

          <div className="modal-body" style={{ padding: '20px', textAlign: 'center' }}>
            {/* Instructions Detail */}
            <div style={{ marginBottom: '20px' }}>
              <p style={{ color: '#555', fontSize: '15px', marginBottom: '5px' }}>
                <strong>Scan using your Sangrah Wallet</strong>
              </p>
              {/* <p style={{ color: '#888', fontSize: '12px' }}>
                Open your app, tap the scan icon, and point your camera at the code below.
              </p> */}
            </div>

            <div className="pop-upbox" style={{ background: '#f9f9f9', padding: '20px', borderRadius: '12px', display: 'inline-block' }}>
              {showButton}
              
              {/* QR Logic - Spinner Removed */}
              {!this.state.response && this.state.qrcode && this.generateCredQrCodeData()}
              
              {this.state.showQr && (
                <div className="qr-wrapper" style={{ border: '10px solid white', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                  {this.qrcode()}
                </div>
              )}
            </div>

            {/* Additional Details Footer (Inside Body) */}
            <div style={{ marginTop: '15px', paddingTop: '20px', borderTop: '1px solid #f0f0f0' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', color: '#000000', fontSize: '13px' }}>
                <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#000000' }}></div>
                Waiting for confirmation…
              </div>
              <p style={{ color: '#888', fontSize: '12px' }}>
                Tip: Ensure your Sangrah app is installed and logged in, then scan the code above.
              </p>
              {/* <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'space-around' }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '10px', color: '#aaa', textTransform: 'uppercase' }}>Protocol</div>
                  <div style={{ fontSize: '12px', fontWeight: 'bold' }}>DIDComm v2</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '10px', color: '#aaa', textTransform: 'uppercase' }}>Security</div>
                  <div style={{ fontSize: '12px', fontWeight: 'bold' }}>End-to-End</div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
</div>




       

      </>
    );
  }
}

export default KycFlow;
